import { userInfoAtom } from 'app/atoms';
import { useUser } from 'app/network/user';
import { AmbassadorStatus } from 'app/schemas/user';
import type { AmbassadorStatusType } from 'app/schemas/user';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';
import { useAtomValue } from 'jotai';

export const VALID_AMBASSADOR_STATUSES: AmbassadorStatusType[] = [
  AmbassadorStatus.CONFIRMED_AMBASSADOR,
  AmbassadorStatus.TRIAL_PERIOD,
];
export const useAmbassador = () => {
  const userInfo = useAtomValue(userInfoAtom);
  const { data: user } = useUser();
  const isEnabled = isFeatureEnabled(FeatureFlag.ambassador, user?.featureFlags ?? userInfo?.featureFlags);

  const isAmbassador = (() => {
    if (!isEnabled) return false;
    const ambassadorStatus = user?.ambassadorStatus ?? userInfo?.ambassadorStatus;
    if (ambassadorStatus === null || ambassadorStatus === undefined) return false;
    return VALID_AMBASSADOR_STATUSES.includes(ambassadorStatus);
  })();

  const canBecomeAmbassador = isEnabled && !isAmbassador;

  return {
    isEnabled,
    isAmbassador,
    canBecomeAmbassador,
  };
};
